const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';

export const toggleNavBar = () => dispatch => {
  dispatch({ type: TOGGLE_NAVBAR });
};

const DEFAULT_STATE = {
  isExpanded: false
};

const navbarReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case TOGGLE_NAVBAR:
      return { ...state, isExpanded: !state.isExpanded };
    default:
      return state;
  }
};

export const selectNavExpanded = state => state.navbar.isExpanded;

export default navbarReducer;
